import { useState } from 'react';
import { DepositsFilters, DepositsListTable } from '../organism';
import { DepositsReportFilterInput, OrderDirectionOption, PageSizeOption, useGetDepositsReportQuery } from '@/graphql/generated';
import { Pagination } from '../molecules';
import { useUserLanguage } from '@/customHooks';
import textsData from '@/textData/reportTexts.json';

const initialFilters: DepositsReportFilterInput = {
  createdAtFrom: null,
  createdAtTo: null,
  statusOption: null,
  reference: null,
  orderDirection: OrderDirectionOption.Desc,
  pageSize: PageSizeOption.TwentyFive,
  page: null,
};

export const DepositReportPage = () => {
  const userLanguage = useUserLanguage();
  const texts = (userLanguage === 'es' ? textsData.es : textsData.en).depositReport;

  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<DepositsReportFilterInput>(initialFilters);

  const handleFilterChange = (newFilters: DepositsReportFilterInput) => {
    setFilters(newFilters);
    setCurrentPage(1);
  };

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    setFilters({ ...filters, page: page.toString() });
  };

  const { data } = useGetDepositsReportQuery({
    variables: {
      filterInput: { ...filters, page: currentPage.toString() },
    },
  });

  const currentDataCount = data?.depositsReport?.items?.length || 0;
  const totalPages = data?.depositsReport?.pagination?.totalPages || 1;
  const showPagination = currentDataCount > 0;

  return (
    <div className="w-full px-4 md:px-6">
      <div className="mb-4">
        <h2 className="text-xl md:text-2xl font-semibold">{texts.title}</h2>
      </div>
      <div>
        <DepositsFilters filters={filters} onFilterChange={handleFilterChange} />
      </div>
      <div>
        <DepositsListTable filters={{ ...filters, page: currentPage.toString() }} />
      </div>
      {showPagination && (
        <div>
          <Pagination
            currentPage={currentPage}
            onPageChange={handlePageChange}
            currentDataCount={currentDataCount}
            pageSize={filters.pageSize || null}
            totalPages={totalPages}
          />
        </div>
      )}
    </div>
  );
};
